import config from 'src/config';
import { ResponseDto } from 'src/dtos/common/responseDto';
import { getData, postData } from 'src/utils/axios/serverHelper';

import { TQC2090_R01Dto } from './Dto_TQC2090_R01';

const baseUrl = `${config.apiUrl}/TQC2090_R01`;

export interface TQC2090_R01Params {
	compCd?: string;
	/** 검사연월 (yyyy-MM) */
	inspectYm?: string;
	/** 조회 시작일 (yyyy-MM-dd) */
	startDate?: string;
	/** 조회 종료일 (yyyy-MM-dd) */
	endDate?: string;
	/** 공정라인 (NI 아연라인 / CR 니켈크롬라인) */
	workplaceCd?: string;
}

export type TQC2090_R01SaveDto = Omit<TQC2090_R01Dto, 'inspectDt'> & {
	inspectDt: string;
};

/** 검사항목 식별정보와 실제 저장된 초중종검사 결과 단일 목록 조회 */
export const getTQC2090_R01List = async (option: string, params: TQC2090_R01Params) => {
	return await getData<ResponseDto<TQC2090_R01Dto[]>>(`${baseUrl}/${option}`, { params });
};

/** 검사결과 일괄 저장 */
export const saveTQC2090_R01 = async (list: TQC2090_R01SaveDto[]) => {
	return await postData<TQC2090_R01SaveDto[], ResponseDto<number>>(`${baseUrl}/save`, list);
};

/** 검사결과 삭제 */
export const deleteTQC2090_R01 = async (list: TQC2090_R01SaveDto[]) => {
	return await postData<TQC2090_R01SaveDto[], ResponseDto<number>>(`${baseUrl}/delete`, list);
};

/** 엑셀 다운로드 */
export const downloadExcel_TQC2090_R01 = async (params: TQC2090_R01Params) => {
	return await getData<ResponseDto<string>>(`${baseUrl}/excel`, { params });
};

/** 검사일지 PDF — 양식은 공정라인(workplaceCd)으로 서버가 결정한다 */
export const downloadReportPdf_TQC2090_R01 = async (params: TQC2090_R01Params) => {
	return await getData<Blob>(`${baseUrl}/report/pdf`, {
		params,
		responseType: 'blob',
		headers: { Accept: 'application/pdf' },
	});
};
